<template>
    <div class="street-view-container">
        <div v-if="!hasStreetView" class="no-data">Street View não disponível para esse local.</div>
        <div ref="streetViewContainer" v-show="hasStreetView" class="street-view" />
    </div>
</template>

<script setup>
import { ref, onMounted, watch, nextTick } from 'vue'
import { Loader } from '@googlemaps/js-api-loader'

const props = defineProps({
    latitude: { type: [String, Number], required: true },
    longitude: { type: [String, Number], required: true }
})

const API_KEY = 'AIzaSyA1GA4MeYkq4qb4TeXvvf4Zz85umj1Vh00'
const streetViewContainer = ref(null)
const hasStreetView = ref(true)
let panorama = null

const loadStreetView = async () => {
    const loader = new Loader({
        apiKey: API_KEY,
        version: 'weekly',
        libraries: []
    })

    await loader.load()

    const svService = new google.maps.StreetViewService()
    const position = { lat: parseFloat(props.latitude), lng: parseFloat(props.longitude) }

    svService.getPanorama({ location: position, radius: 150 }, (data, status) => {
        if (status === google.maps.StreetViewStatus.OK) {
            hasStreetView.value = true

            if (panorama) {
                panorama.setPosition(position)
            } else {
                panorama = new google.maps.StreetViewPanorama(streetViewContainer.value, {
                    pano: data.location.pano,
                    position,
                    pov: { heading: 165, pitch: 0 },
                    zoom: 1,
                    fullscreenControl: false
                })
            }
        } else {
            hasStreetView.value = false
        }
    })
}

watch(() => [props.latitude, props.longitude], loadStreetView)

onMounted(async () => {
    await nextTick()
    loadStreetView()
})
</script>

<style scoped>
.street-view-container {
    width: 100%;
    height: 100vh; /* ou defina um tamanho fixo como 500px */
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    background-color: #f2f2f2;
    display: flex;
    flex-direction: column;
}

.street-view {
    flex: 1;
    width: 100%;
    height: 100%; /* necessário para exibir corretamente o panorama */
}

.no-data {
    flex: 1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    font-weight: bold;
    background-color: #e9ecef;
    text-align: center;
    padding: 16px;
}
</style>
